import { useInvalidateQueries } from '@partful/shared/lib/hooks/useInvalidateQueries';
import { useConfiguration } from '@providers/Configuration';
import { GA } from '@services/gtag';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { FileUploader } from 'src/components/FileUploader';
import { Toast } from 'src/components/Toast';
import { useUpload } from 'src/hooks/Upload/useUpload';
import { useUploadForm } from 'src/hooks/Upload/useUploadForm';
import { UploadSection } from 'src/pages/CreateNewProductPage/styles';
import { useTenant } from 'src/providers/Tenant';
import { postKitsJob } from 'src/services/productInventory';

export function UploadKits() {
  const { t } = useTranslation('manageProduct');
  const { accountId } = useTenant();
  const tenant = useTenant();
  const { name: productName } = useConfiguration();
  const location = useLocation();
  const searchParams = new URLSearchParams(location?.search);
  const configurationPID = searchParams.get('configurationPID') ?? '';

  const { invalidateContentProcessingJobsQueries } = useInvalidateQueries();

  const [toastFileName, setToastFileName] = useState('');
  const {
    mutation: presignedURLMutation,
    uploadFile,
    setUploadedCadFile,
    setRunID: setUploadRunID,
    isSuccess: isUploadSuccess,
    isLoading: isUploadLoading,
    isError: isErrorPresignedUrl,
  } = useUpload(() => postKitsJob({ configurationPID, accountId }));

  const {
    cadFileName: csvFileName,
    handleFileChange,
    handleSubmit,
    setCadFileName: setCsvFileName,
    isTriggerError: isErrorUpload,
    isTriggerSuccess,
  } = useUploadForm({
    mutation: presignedURLMutation,
    setUploadRunID,
    uploadFile,
    setUploadedCadFile,
    isUploadComplete: isUploadSuccess,
    jobParams: {
      account: accountId,
      fileType: 'Kits',
    },
  });

  const handleSubmitAnalytics = (event: React.FormEvent) => {
    GA.ManageProductPage.uploadKitsSpreadsheet(tenant, configurationPID, productName);
    handleSubmit(event);
  };

  useEffect(() => {
    if (isTriggerSuccess && csvFileName) {
      const toastFilename = csvFileName;
      setToastFileName(toastFilename);
      setCsvFileName('');

      invalidateContentProcessingJobsQueries();
    }
  }, [isTriggerSuccess, csvFileName, setCsvFileName, invalidateContentProcessingJobsQueries]);

  return (
    <>
      <UploadSection>
        <FileUploader
          value={csvFileName}
          onChange={handleFileChange}
          loading={isUploadLoading}
          onUpload={handleSubmitAnalytics}
          label=""
        />
      </UploadSection>
      <Toast
        dependency={isErrorPresignedUrl}
        severity="error"
        title={t('errors.errorUploadingTitle')}
        message={t('errors.errorPresignedURLDescription')}
      />
      <Toast
        dependency={isErrorUpload}
        severity="error"
        title={t('errors.errorUploadingTitle')}
        message={t('kits.templates.upload.errorUploadingDescription')}
      />
      <Toast
        dependency={isTriggerSuccess}
        severity="success"
        title={`${toastFileName} has been processed successfully`}
      />
    </>
  );
}
